import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arc1 = _resolveComponent("arc1")!
  const _component_arc2 = _resolveComponent("arc2")!
  const _component_arc3 = _resolveComponent("arc3")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.page, "svg-outer svg-topLayer img-laptop img-all"]),
    style: _normalizeStyle(`height: ${_ctx.height};width:100%;overflow:hidden;position:absolute;z-index: 0;opacity: ${_ctx.opacity_value}; background: ${_ctx.backgroundColor};`),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reloadToggle && _ctx.reloadToggle(...args)))
  }, [
    _createElementVNode("div", {
      class: "arc-1",
      style: _normalizeStyle(_ctx.arc1_setter)
    }, [
      _createVNode(_component_arc1, {
        "stroke-color": _ctx.arc1_color,
        "animate-speed": _ctx.animationSpeed,
        "parent-clicked": _ctx.reload
      }, null, 8, ["stroke-color", "animate-speed", "parent-clicked"])
    ], 4),
    _createElementVNode("div", {
      class: "arc-2",
      style: _normalizeStyle(_ctx.arc2_setter)
    }, [
      _createVNode(_component_arc2, {
        "stroke-color": _ctx.arc2_color,
        "animate-speed": _ctx.animationSpeed,
        "parent-clicked": _ctx.reload
      }, null, 8, ["stroke-color", "animate-speed", "parent-clicked"])
    ], 4),
    _createElementVNode("div", {
      class: "arc-3",
      style: _normalizeStyle(_ctx.arc3_setter)
    }, [
      _createVNode(_component_arc3, {
        "stroke-color": _ctx.arc3_color,
        "animate-speed": _ctx.animationSpeed,
        "parent-clicked": _ctx.reload
      }, null, 8, ["stroke-color", "animate-speed", "parent-clicked"])
    ], 4),
    _createElementVNode("div", {
      ref: "circle_md",
      class: "circle-1",
      style: _normalizeStyle(_ctx.circle_md)
    }, null, 4),
    _createElementVNode("div", {
      class: "circle-2",
      style: _normalizeStyle(_ctx.circle_sm2)
    }, null, 4),
    _createElementVNode("div", {
      ref: "circle_sm",
      class: "circle-2",
      style: _normalizeStyle(_ctx.circle_sm)
    }, null, 4),
    _createElementVNode("div", {
      ref: "circle_lg",
      class: "circle-3",
      style: _normalizeStyle(_ctx.circle_lg)
    }, null, 4)
  ], 6))
}